function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1167179913146({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x2018_\\u043B\\u043E\\u0439_x5F_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 2000",
    style: {
      enableBackground: "new 0 0 3000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3000,
    height: 2000
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF3FA"
    },
    d: "M2776.973,1585.704l-45.867,0.218c-32.318,0.158-78.105,0.366-134.67,0.623 c-13.359,0.079-27.332,0.139-41.858,0.198c-20.682,0.108-42.512,0.208-65.391,0.316l-72.188,0.327 c-672.786,3.126-2032.134,9.153-2033.153,6.798l-0.208-0.376c0,0-0.228-0.366-0.228-0.555 c-0.861-1.514-458.367-438.407,75.049-736.851c208.709-116.768,16.545-169.908,186.87-294.445 c261.513-191.234,616.352,20.187,823.854-63.867c585.952-237.367,811.494-200.536,983.323-159.518 c25.688,6.135,56.424,18.505,87.2,36.159c46.529,26.669,93.167,65.391,122.637,112.821c42.284,68.062,49.201,154.056-30.33,248.094 c-1.583,1.871-3.088,3.78-4.493,5.71c-40.552,55.396-11.785,134.037,37.732,212.163c31.716,50.042,71.932,99.857,107.912,143.23 C3012.459,1385.198,2779.119,1581.924,2776.973,1585.704z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2192.985,
    y: 679.819,
    transform: "matrix(0.9845 -0.1751 0.1751 0.9845 -134.8665 440.772)",
    style: {
      fill: "#D2E0FF"
    },
    width: 474.07,
    height: 609.467
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2577.666,719.146l-135.67,24.132c-1.426,0.254-2.788-0.697-3.041-2.122l0,0 c-0.254-1.426,0.696-2.788,2.122-3.042l135.67-24.132c1.426-0.254,2.788,0.697,3.041,2.123l0,0 C2580.042,717.53,2579.092,718.892,2577.666,719.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2580.812,736.832l-135.669,24.132c-1.427,0.253-2.788-0.697-3.042-2.123l0,0 c-0.253-1.426,0.697-2.788,2.123-3.042l135.669-24.132c1.427-0.254,2.788,0.697,3.042,2.122l0,0 C2583.188,735.217,2582.237,736.579,2580.812,736.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2583.958,754.519l-135.67,24.132c-1.426,0.253-2.788-0.697-3.041-2.123l0,0 c-0.254-1.426,0.696-2.787,2.122-3.041l135.67-24.132c1.426-0.254,2.787,0.697,3.041,2.122l0,0 C2586.334,752.904,2585.384,754.266,2583.958,754.519z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2507.844,822.534l-93.674,16.662c-2.053,0.365-4.012-1.002-4.377-3.054l0,0 c-0.365-2.052,1.003-4.011,3.055-4.376l93.675-16.663c2.052-0.365,4.011,1.003,4.376,3.055l0,0 C2511.264,820.209,2509.896,822.169,2507.844,822.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2592.217,807.526l-57.613,10.247c-2.053,0.365-4.012-1.002-4.377-3.054l0,0 c-0.365-2.052,1.003-4.011,3.055-4.376l57.613-10.248c2.053-0.365,4.012,1.003,4.377,3.054l0,0 C2595.637,805.202,2594.269,807.161,2592.217,807.526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2567.629,837.223l-143.908,25.597c-2.052,0.365-4.011-1.002-4.375-3.054l0,0 c-0.365-2.052,1.002-4.011,3.054-4.376l143.908-25.598c2.052-0.365,4.011,1.002,4.376,3.054l0,0 C2571.049,834.898,2569.682,836.857,2567.629,837.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2475.263,908.182l-93.675,16.662c-2.052,0.365-4.011-1.003-4.376-3.055l0,0 c-0.364-2.052,1.003-4.011,3.055-4.376l93.674-16.662c2.052-0.365,4.012,1.002,4.377,3.054l0,0 C2478.682,905.857,2477.314,907.816,2475.263,908.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2559.636,893.174l-57.614,10.248c-2.051,0.365-4.011-1.003-4.375-3.055l0,0 c-0.365-2.052,1.002-4.011,3.054-4.376l57.614-10.248c2.052-0.365,4.011,1.002,4.376,3.055l0,0 C2563.055,890.85,2561.688,892.809,2559.636,893.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2608.535,909.987l-224.979,40.018c-2.052,0.365-4.011-1.003-4.376-3.055l0,0 c-0.365-2.052,1.003-4.011,3.055-4.376l224.979-40.018c2.052-0.365,4.011,1.003,4.376,3.054l0,0 C2611.955,907.663,2610.587,909.622,2608.535,909.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2483.63,962.054l-93.674,16.662c-2.052,0.365-4.012-1.002-4.376-3.055l0,0 c-0.365-2.052,1.002-4.011,3.054-4.376l93.675-16.662c2.052-0.365,4.011,1.003,4.376,3.054l0,0 C2487.05,959.73,2485.682,961.689,2483.63,962.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2571.727,947.295l-57.613,10.248c-2.053,0.365-4.012-1.003-4.377-3.055l0,0 c-0.364-2.052,1.003-4.011,3.055-4.376l57.614-10.248c2.052-0.365,4.011,1.002,4.376,3.055l0,0 C2575.146,944.971,2573.779,946.93,2571.727,947.295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2537.183,979.04l-143.908,25.597c-2.052,0.365-4.011-1.002-4.376-3.054l0,0 c-0.365-2.052,1.002-4.012,3.055-4.377l143.908-25.598c2.052-0.365,4.011,1.002,4.375,3.055l0,0 C2540.602,976.715,2539.234,978.675,2537.183,979.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2353.311,1230.808l-93.674,16.662c-2.053,0.365-4.012-1.002-4.377-3.054l0,0 c-0.364-2.053,1.003-4.012,3.055-4.377l93.675-16.662c2.052-0.364,4.011,1.003,4.376,3.055l0,0 C2356.73,1228.483,2355.362,1230.443,2353.311,1230.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2441.407,1216.049l-57.614,10.248c-2.052,0.365-4.011-1.003-4.375-3.055l0,0 c-0.365-2.052,1.002-4.011,3.054-4.376l57.614-10.248c2.052-0.365,4.011,1.003,4.376,3.055l0,0 C2444.826,1213.725,2443.459,1215.684,2441.407,1216.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M2406.863,1247.793l-143.908,25.598c-2.052,0.365-4.012-1.002-4.376-3.054l0,0 c-0.365-2.053,1.002-4.012,3.054-4.377l143.908-25.597c2.052-0.365,4.012,1.002,4.377,3.054l0,0 C2410.282,1245.47,2408.915,1247.429,2406.863,1247.793z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59365"
    },
    d: "M2277.105,592.606c0,0,22.182,24.516,23.441,35.773c1.259,11.257-9.965,36.117-4.576,46.958 c1.678,3.375,27.156,36.947,34.967,38.845c5.283,1.284,12.91-11.929,5.348-24.801c-7.658-13.035-9.17-38.915-7.932-50.307 c2.111-19.43,15.876-64.628,18.386-56.142l42.893-6.808l-40.614-16.628L2277.105,592.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2A36D"
    },
    d: "M2263.396,652.047c0,0-3.797,49.233-0.034,68.025c1.509,7.538,8.789,31.782,15.985,34.397 c11.879,4.317,18.373-16.553,13.21-39.214c-1.412-6.202,8.346-44.458,14.856-61.948c16.186-43.482,25.951-69.659,25.951-69.659 L2263.396,652.047z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2617.634,493.486c-10.525,6.175-20.358,12.024-28.913,17.21 c-4.758,2.902-9.131,5.588-12.983,8.016c-6.218,3.92-11.097,7.139-14.18,9.427c-7.889,5.837-20.847,12.961-30.396,22.745 l-0.007,0.014c-0.017,0.017-0.038,0.023-0.056,0.04c-18.627,13.168-19.459,28.699-20.158,38.184 c-1.756,23.522-23.613,58.114-53.305,92.733c-16.19,18.886-30.498,46.503-35.426,57.438c-1.615,3.591-4.641,11.918-8.126,20.726 c-4.85,12.276-10.595,25.479-14.686,28.086c-1.177,0.75-3.159,0.518-5.468-0.354c-5.854-2.188-13.839-8.457-16.178-13.306 c-7.018-14.496-1.556-36.646,11.847-71.675c12.776-33.371,10.923-50.216,5.987-65.11c-3.215-9.681-7.879-18.984-22.184-24.614 c-1.688-0.658-6.867-3.138-13.934-5.095c-6.916-1.915-15.63-3.329-24.603-2.034c-3.106,0.45-6.247,1.218-9.357,2.416 c-7.081,2.711-13.991,7.595-19.955,15.726c-0.19,0.255-0.382,0.511-0.58,0.762l-0.007,0.014c0,0,0,0-0.004,0.007 c-2.356,3.09-5.065,5.974-7.951,8.716c-5.756,5.457-12.252,10.371-18.209,15.345c-5.861,4.904-11.223,9.857-14.846,15.467 l-0.003,0.007c-2.157,3.338-3.704,6.913-4.369,10.834c-2.177,12.775-8.691,25.396-15.183,39.397l-0.003,0.007 c-4.701,10.121-9.39,20.973-12.396,33.134c-7.252,29.259-23.824,32.345-32.515,23.52c-0.108-0.107-0.221-0.225-0.326-0.339 c-2.662-2.871-2.688-18.711-1.978-32.961c0.528-10.666,1.462-20.443,2.017-23.225c1.699-8.68,16.141-42.782,23.08-78.039 c5.177-26.3,46.29-65.584,75.26-117.442c14.42-25.803,69.894-32.914,127.861-66.554c3.12-1.804,6.536-3.043,9.773-4.623 l0.01-0.003c9.252-4.528,18.314-9.411,27.178-14.628c12.961-0.087,26.036,0.529,39.184,1.794 c8.829,0.853,17.683,1.995,26.567,3.428l0.007,0.004c14.098,2.268,28.246,5.243,42.393,8.88 C2588.44,462.751,2604.006,478.094,2617.634,493.486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9FC1F4"
    },
    d: "M2592.229,514.863l-10.03,6.468l-2.626,1.693l-46.51,30.012l-1.961-2.098l-96.198-102.616 l0.276-0.238h0.006c0,0,42.081-29.971,45.307-30.364c0.891-0.112,1.775-0.225,2.659-0.323 c4.758,3.9,12.194,10.341,21.015,18.112c28.258,24.898,70.623,63.452,83.92,75.571 C2590.736,513.5,2592.229,514.863,2592.229,514.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2662.341,487.553l-59.611,42.719c0,0-9.381-3.473-20.533-8.946 c-1.91-0.94-3.879-1.939-5.858-2.988c-6.928-3.671-14.032-7.986-19.633-12.617c-25.977-21.424-49.845-51.329-64.421-71.249 c-0.01,0-0.01-0.01-0.01-0.01c-5.245-7.155-9.282-13.023-11.786-16.744c0.436-0.059,28.777-21.157,59.216-42.987 C2586.233,401.401,2632.871,440.123,2662.341,487.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2A4E96"
    },
    d: "M2542.645,524.461c1.572-2.55,4.914-3.342,7.464-1.769c2.55,1.573,3.342,4.915,1.77,7.464 c-1.573,2.55-4.915,3.342-7.465,1.769C2541.863,530.352,2541.071,527.011,2542.645,524.461z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D2E0FF"
    },
    points: "2125.934,729.125 2385.625,682.932 2353.634,826.606 2169.271,867.599  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C9DF4"
    },
    d: "M2365.11,801.235c4.176,20.938,0.533,41.618-8.909,59.017 c-3.441,6.316-7.635,12.196-12.492,17.482c-5.894,6.462-12.804,12.077-20.505,16.559c-8.167,4.776-17.253,8.283-27.052,10.238 c-5.355,1.068-10.691,1.628-15.961,1.711l-0.004-0.019c-6.938,0.112-13.76-0.605-20.332-2.099 c-6.926-1.544-13.615-3.922-19.888-7.049c-3.914-1.923-7.692-4.175-11.257-6.672c-6.091-4.233-11.633-9.261-16.496-14.929 c-9.467-11.045-16.305-24.591-19.354-39.881c-9.486-47.56,21.376-93.825,68.936-103.311 C2309.355,722.795,2355.624,753.676,2365.11,801.235z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2347.454,828.894c-11.915-28.4-37.753-61.561-56.129-75.613 c-4.226-3.236-8.064-5.453-11.241-6.373c-1.257-0.366-2.464-0.633-3.632-0.831c-11.083-1.93-18.267,2.8-18.267,2.8 c-37.287,2.998-39.445,47.618-36.031,62.145c3.078,13.142,7.304,26.995-1.178,45.995c-0.89,1.989-1.919,4.047-3.106,6.155 c-2.514,4.493-4.384,8.58-5.65,12.3c4.858,5.67,10.4,10.697,16.486,14.933c3.571,2.494,7.353,4.75,11.261,6.67 c6.274,3.127,12.964,5.502,19.891,7.045c6.57,1.495,13.389,2.217,20.326,2.098c-2.355-23.779,15.467-31.409,29.845-32.675 c9.608-0.852,17.684,1.147,17.13,3.058c5.799,0.208,10.509-0.406,14.299-1.742c8.293-2.949,12.033-9.361,12.469-17.822 C2354.341,849.081,2351.838,839.304,2347.454,828.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA561"
    },
    d: "M2259.855,904.124c-6.926-1.544-13.615-3.922-19.888-7.049 c-3.914-1.923-7.692-4.175-11.257-6.672c0.925-3.756,1.637-6.662,2.037-8.194c4.794-18.247,16.707-25.586,16.707-25.586 L2259.855,904.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA561"
    },
    d: "M2343.709,877.734c-5.894,6.462-12.804,12.077-20.505,16.559 c-8.167,4.776-17.253,8.283-27.052,10.238c-5.355,1.068-10.691,1.628-15.961,1.711l-0.004-0.019 c-6.938,0.112-13.76-0.605-20.332-2.099c-6.926-1.544-13.615-3.922-19.888-7.049c2.011-23.705,7.487-40.453,7.487-40.453 s5.578-3.594,16.686-7.383c8.026-2.751,18.924-5.57,32.696-7.228c5.495-0.672,11.475-1.139,17.909-1.353l26.714,34.196 L2343.709,877.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2296.707,841.795c-3.65-5.478-6.899-14.279-9.104-25.537l-1.569,0.647l-26.386,10.919 c0,0,2.349,8.521,3.992,16.662c0.014,0.067,0.027,0.135,0.041,0.202c1.444,7.067-1.952,15.125,9.953,15.667 C2277.314,860.523,2304.374,853.296,2296.707,841.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8945B"
    },
    d: "M2259.647,827.825c0,0,2.35,8.521,3.993,16.662c15.286-3.5,20.614-19.144,22.394-27.581 L2259.647,827.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2256.053,836.56c0,0,36.49-6.655,31.997-29.315c-4.494-22.661-2.812-38.782-26.3-35.491 c-23.488,3.29-26.287,12.833-26.627,20.761C2234.783,800.444,2246.444,837.708,2256.053,836.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2245.074,774.503c0,0,15.26,24.594,31.327,25.476c16.066,0.882,21.879-4.536,21.879-4.536 s-13.58-6.974-19.256-22.745C2279.024,772.698,2250.063,760.354,2245.074,774.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M2247.973,776.169c0,0-6.834,4.234-8.799,10.225c-1.922,5.86-3.063,13.34-0.769,21.78 c0,0-11.106-16.57-4.713-28.472C2240.472,767.082,2247.973,776.169,2247.973,776.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA561"
    },
    d: "M2323.204,894.294c-2.712-1.86-5.648-3.837-8.79-5.934c-3.277-2.171-4.377-7.984-4.389-14.821 c-0.027-14.199,4.721-32.88,4.721-32.88s24.276-3.107,39.179,16.376c0.594,0.749,1.156,1.545,1.702,2.364 c0.198,0.283,0.377,0.57,0.574,0.854c-3.441,6.316-7.635,12.196-12.492,17.482 C2337.815,884.196,2330.905,889.812,2323.204,894.294z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C9DF4"
    },
    d: "M2624.797,1085.251c-4.76-11.133-11.519-20.812-19.673-28.797 c-7.481-7.322-16.14-13.211-25.511-17.505c-22.206-10.153-48.439-11.301-72.614-0.971 c-45.511,19.445-66.717,72.288-47.282,117.799c19.445,45.51,72.288,66.716,117.809,47.271 C2623.035,1183.604,2644.241,1130.761,2624.797,1085.251z M2573.429,1193.479c-40.227,17.188-86.943-1.563-104.132-41.8 c-17.189-40.226,1.563-86.943,41.789-104.132c21.404-9.144,44.639-8.114,64.292,0.9c9.421,4.325,18.011,10.479,25.175,18.238 c5.996,6.481,11.004,14.081,14.665,22.651C2632.406,1129.573,2613.664,1176.291,2573.429,1193.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F77D48"
    },
    d: "M2547.317,1164.093c-3.394,0.016-6.733-1.104-9.459-3.24l-58.19-45.612 c-6.613-5.184-7.771-14.748-2.588-21.361c5.184-6.612,14.748-7.773,21.361-2.588l42.848,33.585l45.613-102.288 c3.421-7.675,12.418-11.126,20.092-7.7c7.675,3.423,11.123,12.419,7.699,20.093l-53.552,120.094 c-1.908,4.281-5.683,7.441-10.23,8.571C2549.723,1163.939,2548.516,1164.088,2547.317,1164.093z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M932.388,1157.68c0,0,95.697-54.175,50.584-126.887c0,0-36.027-44.609-74.459-55.944 c0,0,20.973,108.644,0.516,111.298C888.572,1088.8,894.388,963.4,894.388,963.4s-101.289-48.144-140.929-44.123 c0,0,63.177,105.891,42.696,103.427c-20.48-2.464-91.339-109.598-91.339-109.598s-103.711-18.709-120.057,42.774 s10.661,92.061,26.031,95.828c15.369,3.767,113.868,2.03,111.369,14.835c-2.5,12.805-68.927,33.582-106.08,22.24 c0,0,41.405,100.874,95.111,95.508c53.707-5.366,70.183-38.705,103.433-41.418c33.25-2.713,57.597,6.13,41.008,15.162 c-16.589,9.032-72.905,3.272-99.665,26.236c-26.759,22.964-48.441,37.137,1.498,47.14s139.459,3.191,157.192-35.271 C932.388,1157.68,932.388,1157.68,932.388,1157.68z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M632.182,974.85c0,0,269.053,85.746,300.207,182.83c0,0-1.078,43.501,26.018,93.269l0.089,19.189 c0,0-28.447-65.113-43.839-73.997C914.656,1196.141,974.391,1111.43,632.182,974.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AEC3FF"
    },
    d: "M958.407,1250.948c0,0,41.722,62.722,18.458,139.415l-10.672-2.813c0,0,9.955-84.4-11.917-126.725 C932.403,1218.501,958.407,1250.948,958.407,1250.948z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2E0FF"
    },
    d: "M1115.151,1263c0,0,249.611-36.319,346.503,135.504c0,0,18.31,33.645-15.976,60.798 c-34.286,27.154-62.336-43.039-95.163-80.311C1317.688,1341.721,1211.275,1266.633,1115.151,1263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2E0FF"
    },
    d: "M1156.252,1241.992c0,0,181.669-93.601,301.18,12.51c0,0,22.894,20.952,3.781,50.79 c-19.112,29.839-59.1-16.548-94.072-36.453S1230.854,1219.446,1156.252,1241.992z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2E0FF"
    },
    d: "M2758.033,1475.123c-13.928,5.379-106.307,15.624-102.422,27.303 c3.873,11.679,68.536,23.115,101.934,8.028c0,0-12.441,46.498-36.598,76.337c-29.914,0.148-72.287,0.345-124.624,0.588 c-5.758-1.715-11.65-2.688-18.041-2.391c-7.599,0.352-14.64,1.285-20.7,2.57c-19.138,0.099-39.345,0.192-60.512,0.29l-66.805,0.31 c-21.71-18.929-40.916-48.428-23.019-87.758c0,0,28.336-46.077,62.93-61.318c0,0-6.522,104.192,12.933,104.211 c19.465,0.009-1.096-116.626-1.096-116.626s88.985-57.254,126.555-58.27c0,0-46.352,106.693-27.483,101.926 c18.869-4.778,72.257-113.563,72.257-113.563s94.791-30.008,117.492,25.551 C2793.545,1437.879,2771.962,1469.745,2758.033,1475.123z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2E0FF"
    },
    d: "M2728.648,1405.831c-149.396,83.154-209.286,142.846-231.578,182.018l-17.802,0.083 C2527.027,1500.756,2723.613,1408.189,2728.648,1405.831z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8FCFF"
    },
    d: "M1206.912,806.813c0,0,29.921-56.092,102.12-50.209c0,0,104.346-93.743,216.452-13.438 c0,0,118.678-20.577,206.811,16.381c58.76,24.641,78.251,50.685,78.251,50.685L1206.912,806.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8FCFF"
    },
    d: "M1521.283,637.559c0,0,23.018-43.103,78.561-38.582c0,0,80.272-72.035,166.517-10.327 c0,0,91.298-15.812,159.098,12.586c45.204,18.935,60.198,38.947,60.198,38.947L1521.283,637.559z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6980E2"
    },
    d: "M1424.934,1588.397l-226.738-388.552l-8.488-14.569l-105.801,69.027l33.806,58.416l160.116,276.386 l1.699,2.828l147.103-0.708L1424.934,1588.397z M1250.105,923.318l-229.567,353.898l-52.051,80.202l18.953,138.332l33.806-47.524 l96.466-135.506l80.483-112.874l197.316-277.236L1250.105,923.318z M1021.246,1448.226l-0.708-171.01l-1.697-352.765 l-126.029,0.566l3.112,665.788v2.828l126.028-0.566v-2.828L1021.246,1448.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6980E2"
    },
    d: "M2279.974,1372.409c-6.931,30.696-19.802,54.458-38.756,71.006 c-18.954,16.69-42.15,25.036-69.733,25.178c-35.645,0.142-63.084-10.467-82.462-31.825 c-19.521-21.358-29.281-51.626-29.423-90.807l-0.848-183.597c-0.283-39.181,9.336-69.735,28.571-91.374 c19.097-21.642,46.536-32.675,82.181-32.816c17.964-0.142,34.372,3.961,48.939,12.166c14.57,8.201,27.018,20.084,37.202,35.5 c10.185,15.418,17.964,34.373,23.196,56.72l130.695-0.708c-8.486-48.656-23.62-90.241-45.403-124.611 c-21.783-34.371-49.224-60.539-82.323-78.503c-32.954-17.822-70.723-26.735-113.015-26.59 c-51.202,0.283-94.769,10.326-130.696,30.126c-35.926,19.663-63.226,48.232-82.037,85.576 c-18.953,37.34-28.147,82.461-28.006,135.22l0.848,183.459c0.283,53.042,10.042,98.021,29.139,135.078 c19.236,36.919,46.819,65.066,83.028,84.445c15.417,8.202,29.438,17.046,47.685,21.569c12.166,3.253,27.848,3.322,41.426,4.738 l79.211-0.425c12.022-1.554,23.621-3.961,34.654-7.355c14.144-4.099,27.723-9.617,40.453-16.406 c32.814-17.539,59.833-42.858,81.331-76.097c21.5-33.241,36.351-73.271,44.697-120.229L2279.974,1372.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6980E2"
    },
    d: "M1947.151,920.065l-131.971,0.708l-126.593,288.411l-129.141-287.278l-131.969,0.566 l198.732,409.768l1.131,255.166v2.832l126.029-0.566v-2.828l-1.133-255.17L1947.151,920.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M946.834,612.085c0,0-23.153-3.804-37.769,7.346c-14.616,11.15-16.979,7.575-25.227,14.458 c-8.247,6.883,0.265,14.992-4.277,19.577c-4.542,4.584-4.679,13.385,2.102,15.636c6.781,2.25,2.275,14.657,16.95,16.219 c14.675,1.562,8.135,8.382,22.049,9.35c13.915,0.968,25.425,1.393,32.773,4.433c7.348,3.041,13.977-0.166,16.048-5.758 c2.071-5.593,7.971,1.58,9.647-6.061c1.676-7.641-4.449-10.627-1.056-16.836C981.471,664.239,989.727,620.198,946.834,612.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M988.906,1055.936c-1.59,1.865-1.771,3.93-0.948,6.124c0.001,0.009,0.006,0.022,0.016,0.03 c1.523,4.057,6.446,8.551,12.158,13.027c0.73,0.576,1.379,1.099,1.945,1.584c0.148,0.127,0.297,0.255,0.437,0.383 c0.115,0.099,0.226,0.202,0.336,0.296c5.333,4.803,3.361,5.94,12.955,15.699c10.94,11.119,18.384,11.234,20.489,10.186 c1.781-0.895-1.928-6.816-6.038-13.473c-0.199-0.321-0.395-0.646-0.599-0.971c-0.547-0.885-1.091-1.784-1.635-2.674 c-4.819-8.013-3.65-11.813-2.671-23.833c0.796-9.768,14.542-54.689,14.542-54.689l-20.754-3.326c0,0-5.821,35.711-12.63,41.279 c-3.641,2.969-7.754,3.054-11.261,5.264c-0.247,0.153-0.491,0.311-0.729,0.473C992.528,1052.668,990.5,1054.065,988.906,1055.936 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M988.906,1055.936c-1.59,1.865-1.771,3.93-0.948,6.124c0.001,0.009,0.006,0.022,0.016,0.03 c1.853,4.049,6.655,8.521,12.177,12.986c0.722,0.584,1.359,1.122,1.926,1.625c0.148,0.127,0.297,0.255,0.437,0.383 c0.115,0.099,0.226,0.202,0.336,0.296c5.333,4.803,3.361,5.94,12.955,15.699c10.94,11.119,18.384,11.234,20.489,10.186 c1.781-0.895-1.928-6.816-6.038-13.473c-2.113-0.747-11.933-4.603-19.433-13.972c-6.365-7.93-10.743-18.08-15.084-24.293 c-0.47-0.082-0.75-0.131-1.22-0.213C992.529,1052.668,990.5,1054.065,988.906,1055.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1155.774,1041.046c1.354,6.379,10.455,5.205,20.608,2.599c10.153-2.607,7.768,0.379,22.24-1.395 c14.473-1.774,18.799-7.229,19.216-9.389c0.374-1.916-6.795-2.507-14.485-3.302c-0.967-0.098-1.938-0.206-2.91-0.313 c-8.685-0.987-15.1-6.508-23.03-11.012c-7.512-4.266-18.853-21.87-18.853-21.87l-19.855,1.806c0,0,10.614,15.719,14.728,22.558 c2.42,4.023,2.357,9.381,2.109,13.521C1155.415,1036.5,1155.295,1038.799,1155.774,1041.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M1176.383,1043.645c10.153-2.607,7.768,0.379,22.24-1.395c14.473-1.774,18.799-7.229,19.216-9.389 c0.374-1.916-6.795-2.507-14.485-3.302l-0.07,0.148c0,0-8.618,6.264-20.678,6.693c-9.829,0.354-20.275-2.341-27.063-2.152 c-0.127,2.251-0.247,4.55,0.232,6.797C1157.128,1047.425,1166.229,1046.251,1176.383,1043.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED7D2B"
    },
    d: "M1078.127,914.859l-17.994,50.21l-23.491,65.559c0,0-6.575,0.712-12.899-1.027 c-5.823-1.609-12.533-5.92-12.533-5.92s5.915-70.165,18.009-110.545c3.099-10.365,6.61-18.76,10.536-23.508 C1058.963,866.381,1078.127,914.859,1078.127,914.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1058.31,835.686c-10.615-3.288-37.838-2.417-67.704,3.351 c-8.252,1.593-16.962,0.724-21.403-6.411l0,0l-75.39-5.002c0,0-23.355,52.316-10.193,90.371 c2.554,7.384,14.621,7.588,14.623,7.592c0,0,44.155,0.277,58.711,0.107c37.458-0.438,78.974-26.675,84.371-27.82 c8.834-1.875,12.583,15.793,21.654,34.283c9.071,18.49,84.192,81.371,84.192,81.371s11.432-0.02,16.134-1.846 c5.056-1.964,6.885-4.46,6.885-4.46S1085.862,844.22,1058.31,835.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M944.92,716.595c0.119,0.075-13.143,4.776-22.092,0.938c-8.419-3.604-14.925-17.31-14.801-17.318 c3.808-0.221,7.952-3.601,10.918-25.496l1.629,0.563l27.394,9.497c0,0-1.874,8.776-3.055,17.125 C943.919,708.913,943.419,715.623,944.92,716.595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED975D"
    },
    d: "M947.968,684.778c0,0-1.137,6.149-2.714,14.938c-15.702-2.637-22.374-15.989-24.679-24.435 L947.968,684.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M952.132,693.419c0,0-37.381-4.573-34.175-27.808c3.207-23.235,0.541-39.475,24.544-37.537 c24.003,1.938,27.407,11.442,28.223,19.458C971.54,655.547,961.939,694.009,952.132,693.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M969.215,634.833c0,0-23.652,20.869-39.884,22.719c-16.232,1.85-22.445-3.294-22.445-3.294 s9.485-8.065,15.1-20.967c1.654-3.802,5.216-6.443,9.342-6.848C942.92,625.306,964.913,624.591,969.215,634.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M954.258,633.164c0,0,8.083,7.635,10.668,13.337c2.494,5.503,3.377,18.725,1.504,24.001 c0,0,12.17-24.36,4.982-36.043C963.789,622.072,954.258,633.164,954.258,633.164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C9DF4"
    },
    d: "M976.991,771.207c-0.245,75.564,0.389,59.767-7.792,67.032c-1.971,1.749-7.557,2.844-14.919,3.417 c-23.148,1.809-63.917-1.532-65.515-5.795c-5.517-14.751-1.798-19.398-6.521-42.025c-0.493-2.406-1.099-5.01-1.807-7.846 c-3.899-15.534-7.579-20.79,5.316-45.97c11.694-22.808,23.903-41.352,25.028-40.701c31.771,18.361,34.131,2.588,34.131,2.588 S977.113,734.349,976.991,771.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1060.133,965.068l-23.491,65.559c0,0-6.575,0.712-12.899-1.027 c-5.823-1.609-12.533-5.92-12.533-5.92s5.915-70.165,18.009-110.545L1060.133,965.068z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C9DF4"
    },
    d: "M944.913,701.903c0,0,32.531,5.124,36.506,19.059c3.976,13.934,27.372,95.848,27.372,95.848 s-16.47,3.158-24.184-4.377c-7.714-7.535-27.358-70.429-27.358-70.429L944.913,701.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6980E2"
    },
    d: "M954.28,841.656c-23.148,1.809-63.917-1.532-65.515-5.795 c-5.517-14.751-1.798-19.398-6.521-42.025l10.806-31.594c0,0-1.438,35.059,9.003,44.153c10.43,9.095,42.514,17.295,47.626,24.937 C952.144,834.998,953.781,838.685,954.28,841.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M927.565,827.229c0,0,22.795-5.356,26.507-3.371c3.711,1.985,12.81,9.266,13.969,11.823 c1.158,2.557-8.233-1.855-11.28-2.634c-1.974-0.504-7.13,1.355-9.684,2.24c-10.744,3.722-17.375,1.949-17.375,1.949 L927.565,827.229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8C9DF4"
    },
    d: "M910.761,699.303c0,0-30.666,2.25-41.116,17.191c-14.711,21.033-43.338,110.27-26.197,121.927 c19.303,13.128,87.183,2.474,87.183,2.474s2.139-10.603-1.069-15.682c-3.208-5.079-54.465-12.746-56.854-15.079 c-2.389-2.333,28.978-46.389,28.895-53.473C901.519,749.576,910.761,699.303,910.761,699.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M955.252,830.207c0,0,4.861,6.121,6.44,6.84c1.579,0.719,2.591,0.523,2.591,0.523l-3.295-5.771 L955.252,830.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M954.072,823.859l14.002,6.598c0,0-0.581,0.976-2.296,0.918c-1.715-0.059-6.058-1.589-6.058-1.589 L954.072,823.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#233862"
    },
    points: "958.759,842.122 1068.894,840.833 1101.062,758.06 991.096,759.346  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#233862"
    },
    points: "1070.147,837.609 924.714,839.309 924.751,842.519 1068.894,840.833  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBF3FA"
    },
    d: "M1040.61,799.965c0.797-2.906-0.905-5.234-3.801-5.2c-2.896,0.034-5.89,2.417-6.686,5.322 c-0.797,2.906,0.905,5.234,3.801,5.2C1036.82,805.254,1039.814,802.871,1040.61,799.965z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B3051"
    },
    d: "M2046.181,1586.116c0,0-0.051-11.089,1.685-14.784c1.735-3.696,8.092-18.738,8.092-18.738 l25.121-0.117c0,0,4.736,13.675,5.049,18.15c0.313,4.477,0.071,15.304,0.071,15.304L2046.181,1586.116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B3051"
    },
    d: "M2190,1585.553c0,0-0.051-11.09-1.648-14.77s-7.462-18.666-7.462-18.666l-22.651,0.104 c0,0-4.15,13.716-4.393,18.194c-0.243,4.479,0.07,15.304,0.07,15.304L2190,1585.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2096.368,963.563c0,0-0.684,24.696-3.793,35.773l-24.933,17.565l94.226,13.654l-22.601-30.923 c0,0-6.933-33.076-3.434-45.34C2139.333,942.03,2096.368,963.563,2096.368,963.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED985F"
    },
    d: "M2096.247,966.974c0.001-0.007,7.529,17.89,21.553,17.43c14.023-0.461,17.142-16.335,17.142-16.335 L2096.247,966.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C3A64"
    },
    d: "M2087.809,952.5c0,0-4.635-22.59-7.827-29.423c-3.192-6.833-5.968-37.374,29.056-39.117 c0,0,13.439,1.518,20.794-2.994c0,0,0.021,4.477-1.815,6.066c0,0,12.103-2.954,21.633,7.538c9.531,10.492-6.1,47.439-5.27,56.127 L2087.809,952.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2116.16,977.485c-10.163-0.132-28.931-13.577-29.009-30.335l-0.121-26.149 c-0.028-6.119,4.216-11.145,9.431-11.17l38.771-0.18c5.215-0.024,9.505,4.963,9.533,11.082l0.114,24.669 C2144.961,962.975,2127.816,977.637,2116.16,977.485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C3A64"
    },
    d: "M2087.096,934.963c0,0-0.021-15.712,12.414-18.186c12.434-2.474,40.334,7.472,44.23-4.004 c3.898-11.476-53.89-11.01-56.766-3.688C2084.1,916.407,2087.096,934.963,2087.096,934.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2047.239,1202.172c0,0,4.524,120.999-1.081,190.076s0.809,165.145,0.809,165.145 s19,10.361,39.496-0.183c0,0,21.912-133.502,21.622-165.249c-0.308-33.809,23.667-184.905,23.667-184.905L2047.239,1202.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M2189.048,1556.73c0,0-18.899,10.542-39.492,0.184c0,0-23.146-133.291-23.151-165.04 c-0.002-14.278-4.527-49.444-9.758-85.294c-7.158-49.045-15.625-99.379-15.625-99.379l87.737-5.891 c0,0-6.676,121.26-0.429,190.276C2194.576,1460.611,2189.048,1556.73,2189.048,1556.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M2126.404,1391.874c-0.002-14.278-4.527-49.444-9.758-85.294 c5.154-21.453,17.859-42.136,17.859-42.136C2150.915,1309.804,2126.404,1391.874,2126.404,1391.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DDBF"
    },
    d: "M2264.971,1113.54c-30.921-74.54-85.869-112.779-125.703-113.906 c-8.685,11.648-14.946,14.372-22.92,17.569c-12.864-1.719-23.771-17.503-23.772-17.866 c-14.015,1.501-77.159,8.889-119.637,113.126c-3.312,8.126-3.864,27.418,11.474,46.351c10.912,13.462,27.989,31.004,54.445,51.592 c0,0,2.465-5.33,4.692-13.945c0,0-15.811-30.419-25.341-51.022c-4.629-10.029-10.037-21.51,24.277-45.121 c0.973,26.191,5.329,57.209,2.104,85.266c-4.307,37.42,3.275,36.721,3.275,36.721s10.219,1.952,24.466,3.774 c12.888,1.663,29.069,3.224,43.956,3.154c34.135-0.158,71.516-7.577,71.516-7.577c4.084,0.031,5.655-9.255,5.914-22.995 c2.046,6.875,4.002,11.009,4.002,11.009c26.264-20.832,43.179-38.531,53.965-52.093 C2266.846,1138.501,2268.333,1121.645,2264.971,1113.54z M2217.764,1144.513c-7.594,17.991-20.639,42.888-24.007,49.557 c-0.016-22.402-2.803-54.009-4.08-77.436c-0.42-7.717-0.858-14.889-1.31-21.569 C2209.336,1111.792,2228.555,1118.946,2217.764,1144.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2093.858,993.31c0,0-6.407,2.106-7.57,6.852c0,0,19.084,16.828,30.06,17.041L2093.858,993.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2116.348,1017.203l21.53-24.969c0,0,6.731,2.919,6.69,7.76 C2144.568,999.994,2125.657,1017.818,2116.348,1017.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2112.436,1015.391c0,0-15.861,142.702-10.026,160.061c3.004,8.936,7.004,16.658,10.179,22.049 c2.284,3.877,7.907,3.841,10.136-0.069c4.353-7.638,10.034-18.687,10.009-24.281c-0.043-9.062-13.269-157.914-13.269-157.914 L2112.436,1015.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M2108.08,1008.419c0,0,9.98-1.047,16.063-0.458c1.206,0.116,1.885,1.433,1.301,2.494 c-1.689,3.075-5.143,8.408-8.777,8.426C2111.559,1018.904,2103.552,1008.793,2108.08,1008.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2107.986,960.679c0,0,3.186,4.267,8.713,4.088c5.526-0.179,8.107-4.167,8.107-4.167 S2115.473,959.115,2107.986,960.679z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2040.431,1197.979c0,0,12.184-11.086,19.99-5.887c8.258,5.499,11.974,13.652,7.345,14.238 c-4.511,0.57-18.609-1.017-19.916,1.097c-1.308,2.112-7.189,6.168-8.995,2.978 C2037.049,1207.213,2040.431,1197.979,2040.431,1197.979z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2043.55,1196.46c-2.228,8.615-4.692,13.945-4.692,13.945 c-26.456-20.589-43.533-38.13-54.445-51.592c8.176-0.646,20.102-3.625,33.797-13.376 C2027.739,1166.041,2043.55,1196.46,2043.55,1196.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2196.028,1197.258c0,0-10.48-9.609-19.598-3.107c-5.089,3.628-8.638,13.181-4.163,12.369 c4.474-0.811,15.104-1.847,16.43,0.254c1.327,2.101,6.16,5.186,9.021,2.894 C2201.213,1206.869,2196.028,1197.258,2196.028,1197.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M2192.895,1195.768c2.309,8.595,4.822,13.9,4.822,13.9c26.264-20.832,43.178-38.531,53.965-52.093 c-8.182-0.571-20.135-3.439-33.92-13.063C2208.423,1165.203,2192.895,1195.768,2192.895,1195.768z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1493.15,956.627c-12.856-4.203-21.716,1.218-21.716,1.218c-36.95,1.69-40.59,45.703-37.711,60.169 c2.871,14.466,7.101,29.817-5.989,51.372c-37.808,62.262,60.527,48.602,60.527,48.602c-6.327-43.751,48.566-36.414,47-31.619 C1604.922,1091.458,1522.387,966.185,1493.15,956.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DDBF"
    },
    d: "M1455.695,1145.811c0,0-3.479,6.97-9.812,14.989c-7.632,9.65-48.032-12.985-44.569-14.737 c3.463-1.752,23.441-60.178,28.226-67.529c4.791-7.353,21.203-11.235,21.203-11.235L1455.695,1145.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1593.494,1538.603c0,0,11.169,10.098,9.032,17.319s-12.15,12.075-13.466,20.896 s-6.719,13.653-11.601,13.676c-4.883,0.022-23.277,0.107-23.277,0.107s-3.623-6.186,5.048-8.095 c8.672-1.91,11.896-12.282,11.31-21.896c-0.587-9.612,0.71-22.438,0.71-22.438l18.425-4.359L1593.494,1538.603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M1499.385,1543.348c0,0,4.2,42.978-0.671,45.404l-62.485,0.161c0,0-0.034-7.212,9.996-8.86 c10.028-1.649,27.633-7.607,30.556-20.708S1499.385,1543.348,1499.385,1543.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1542.482,1234.68c-12.992-28.776-20.898-37.018-19.438-45.975 c1.087-6.666-3.979-124.186-3.979-124.186c-1.528-0.466-4.588-0.875-6.263-1.238c-5.279-1.147-9.662-4.831-11.502-9.911 c-2.217-6.119-4-15.161-4.011-26.502l-1.646,0.332l-27.669,5.612c0,0,0.67,8.713,0.727,16.924c0,0.068,0.001,0.137,0.001,0.204 c0.067,7.131-4.582,13.446-11.424,15.456c-3.494,1.025-6.533,1.902-6.533,1.902s-10.035,29.081-11.839,58.917 s18.691,42.699,0.321,102.39C1420.472,1289.568,1549.659,1250.581,1542.482,1234.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8945B"
    },
    d: "M1467.974,1032.813c0,0,0.671,8.713,0.728,16.924c15.496-0.509,23.622-14.685,26.942-22.536 L1467.974,1032.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1466.356,1044.399c0,0,36.281-5.339,32.609-27.882c-3.673-22.544-1.464-38.415-24.784-35.959 c-23.32,2.456-26.408,11.79-27.012,19.612C1446.564,1007.993,1456.824,1045.208,1466.356,1044.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1457.61,982.709c0,0,14.246,24.818,30.091,26.233c15.845,1.415,21.773-3.74,21.773-3.74 s-13.183-7.351-18.256-23.126C1491.218,982.076,1463.019,968.898,1457.61,982.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#163560"
    },
    d: "M1460.418,984.453c0,0-6.896,3.952-9.04,9.806c-2.098,5.725-3.478,13.077-1.497,21.495 c0,0-10.413-16.749-3.692-28.292C1453.314,975.221,1460.418,984.453,1460.418,984.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DDBF"
    },
    d: "M1545.473,1116.393c0,0,0.992,13.124,0.134,28.881c-0.57,10.445-11.068,24.481-12.551,27.948 c-3.72,8.694-7.954,10.126-7.954,10.126l-32.771,8.193l-11.522,2.877l-36.428-10.696c0,0-16.783-46.17-10.251-72.233 c6.532-26.064,16.613-44.19,16.613-44.19s29.818,28.927,68.323-2.781L1545.473,1116.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2CCAA"
    },
    d: "M1548.733,1145.625c-0.57,10.444-14.195,24.13-15.678,27.597 c-3.72,8.694-7.954,10.126-7.954,10.126l-32.771,8.193l-8.809-12.302c0,0,53.042-15.017,42.768-61.795L1548.733,1145.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED7D2B"
    },
    d: "M1446.727,1190.73c0,0-17.754,56.157-18.823,75.254s35.693,271.047,37.166,279.836 c1.388,8.286,11.709,13.524,11.709,13.524s4.749,2.771,11.499,0.832c9.365-2.691,12.314-5.876,12.314-5.876 s13.188-179.871,4.213-244.062c-8.975-64.19-9.334-119.734-9.334-119.734L1446.727,1190.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M1523.045,1188.705c0,0,27.65,36.743,30.328,61.656c2.677,24.912,4.54,112.454,10.11,136.727 s25.84,70.939,26.191,146.725c0,0-2.064,4.354-8.489,6.697c-2.055,0.749-4.809,1.479-7.483,2.106 c-5.302,1.241-10.76-1.327-13.204-6.193c-13.684-27.233-57.277-115.07-59.576-133.334c-1.627-12.926-15.659-98.456-45.635-148.542 c-7.196-12.025,4.104-60.029,4.104-60.029L1523.045,1188.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1471.23,1029.86c0,0-0.189,2.759-6.865,3.434c0,0-5.604,0.567-5.913-2.38 C1458.452,1030.914,1463.491,1027.954,1471.23,1029.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED7D2B"
    },
    d: "M1443.809,1182.088c0,0,7.259,5.688,21.627,5.91c17.163,0.266,59.664-4.651,59.664-4.651 s1.914,5.27,1.863,10.845c0,0-51.875,13.341-82.018,2.293C1444.945,1196.484,1441.03,1189.2,1443.809,1182.088z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1461.388,1202.806c-4.318,0.02-7.849-3.939-7.872-8.826c-0.022-4.888,3.472-8.879,7.79-8.899 c4.318-0.02,7.849,3.939,7.871,8.826C1469.2,1198.794,1465.706,1202.785,1461.388,1202.806z M1461.317,1187.676 c-2.887,0.014-5.222,2.836-5.206,6.291c0.016,3.456,2.377,6.257,5.265,6.243c2.886-0.014,5.222-2.835,5.206-6.291 S1464.204,1187.662,1461.317,1187.676z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#163560"
    },
    points: "1498.982,1218.753 1420.928,1219.845 1382.099,1129.755 1460.153,1128.663  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1488.584,1178.009l-5.754-7.005c0,0-3.888-3.436-6.701-4.01s-8.762-3.969-9.333-3.002 c-0.571,0.968,4.595,7.821,4.595,7.821l0.261,0.037c-5.873,4.459-20.77,0.615-22.598,2.432c-2.215,2.202,3.096,6.915,5.947,9.563 s10.987,7.045,17.306,5.046c4.618-1.461,11.892-2.96,11.892-2.96L1488.584,1178.009z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M1388.044,1145.606c0,0,4.88-5.597,8.014-2.936c3.134,2.661-0.744,15.835-3.724,14.511 C1389.355,1155.857,1386.342,1147.25,1388.044,1145.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9DDBF"
    },
    d: "M1519.066,1064.517c0,0,26.037,1.704,36.127,25.912s28.834,75.837,28.866,82.688 c0.031,6.851-20.278,32.149-100.296,13.036c0,0-2.759-7.661,2.565-11.562c0,0,55.636-18.147,55.524-21.706 c-0.211-6.73-7.588-12.514-38.856-43.503C1494.496,1100.956,1519.066,1064.517,1519.066,1064.517z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2E0FF"
    },
    d: "M1071.417,1592.839l110.864-0.514c5.917-5.067-4.188-16.465-14.694-17.186 c-4.563-0.323-10.328,0.658-16.912,2.081c-1.619-20.256-10.754-111.308-43.572-107.495c-36.9,4.269,0.186,40.115,10.722,61.392 c7.804,15.758,16.065,38.37,19.841,49.041c-2.994,0.664-6.094,1.315-9.261,1.913c-4.963-15.002-23.405-65.456-46.546-62.405 c-27.169,3.574-16.148,23.787,3.176,35.726c14.177,8.779,31.595,21.271,39.872,27.306c-6.984,1.174-14.274,1.977-21.674,1.838 C1084.241,1584.173,1074.997,1589.812,1071.417,1592.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2E0FF"
    },
    d: "M1904.474,1588.977l-92.898,0.432c-4.998-4.2,3.381-13.829,12.179-14.514 c3.821-0.308,8.658,0.471,14.187,1.611c1.199-16.985,8.146-93.349,35.675-90.409c30.952,3.29,0.156,33.614-8.507,51.523 c-6.417,13.265-13.163,32.276-16.244,41.247c2.514,0.533,5.116,1.054,7.774,1.53c4.043-12.608,19.104-55.028,38.517-52.651 c22.794,2.783,13.716,19.806-2.384,29.959c-11.812,7.467-26.309,18.068-33.196,23.19c5.86,0.929,11.976,1.544,18.175,1.371 C1893.661,1581.815,1901.45,1586.469,1904.474,1588.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M2835.716,1584.72v1.416c0,1.554-1.274,2.97-2.972,2.97l-623.352,2.828l-79.211,0.425 l-1812.488,8.347c-1.557,0-2.972-1.274-2.972-2.974v-1.271c0-1.699,1.273-2.97,2.972-2.97l578.23-2.687l126.028-0.566 l255.876-1.133l147.106-0.708l202.408-0.991l126.029-0.563l338.196-1.558l152.479-0.708l588.697-2.687 C2834.441,1581.75,2835.716,1583.166,2835.716,1584.72z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F78248"
    },
    d: "M936.582,1571.576c-1.508,0.97-3.042,1.909-4.602,2.818c-0.528,0.309-1.057,0.612-1.586,0.905 c-1.208,0.682-2.417,1.338-3.637,1.979c-58.442,30.442-131.094,9.863-164.622-47.684 c-31.98-54.891-17.134-124.172,32.317-161.539c3.945-2.98,8.104-5.758,12.482-8.306c1.57-0.915,3.156-1.794,4.749-2.628 c1.547-0.817,3.11-1.6,4.679-2.341c4.808-2.282,9.706-4.225,14.658-5.837c7.361-2.41,14.852-4.093,22.375-5.066 c23.332-3.033,46.966,0.682,68.074,10.396c22.398,10.301,41.955,27.357,55.31,50.275 C1010.398,1462.264,992.271,1535.867,936.582,1571.576z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C3A64"
    },
    d: "M775.146,1030.238c0.372-1.523-33.012,15.276-34.7,17.166 c-15.612,17.48-11.032,40.176-2.052,40.352c5.76,0.113,4.688,9.693,4.688,9.693l64.031-27.438 C807.112,1070.012,799.179,1025.002,775.146,1030.238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C3A64"
    },
    d: "M783.061,1033.716c0,0-16.038-28.643-50.044-12.265c-17.979,8.659-19.229,46.811-26.327,53.359 c-15.896,14.666-22.473,20.039-19.553,44.764c2.92,24.726,80.164,55.375,75.761,75.863c0,0,31.503-39.075,6.026-63.143 c-9.581-9.051-20.234-31.002-19.232-34.877C750.694,1093.545,783.061,1033.716,783.061,1033.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED985F"
    },
    d: "M758.25,1151.415c-4.402-20.716-31.318-27.021-43.961-10.029 c-2.273,3.056-3.867,6.662-4.372,10.915c-2.795,23.55,35.282,119.245,40.712,127.901c9.885,15.758,67.912,69.663,67.912,69.663 l10.619-6.504c0,0-41.302-69.188-47.678-75.65C774.111,1260.237,766.608,1190.748,758.25,1151.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED985F"
    },
    d: "M814.463,1343.459c0,0,15.494-10.275,21.38-9.646c5.886,0.631,22.936,5.451,23.156,7.953 c0.219,2.502-18.954,4.152-20.235,5.527c-1.281,1.375-14.265,10.129-18.999,7.424 C815.031,1352.014,814.463,1343.459,814.463,1343.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M707.129,1574.489l-13.893-1.976c0,0-46.853-36.881-54.126-106.069 c-0.742-7.04-0.923-14.19-0.431-21.4c0.058-0.831-0.039-1.663-0.496-2.359c0-0.005-0.005-0.01-0.015-0.021 c-1.505-2.283-5.25-8.004-10.322-16.142c-5-8.016-13.563-23.176-22.986-40.189c-16.975-30.638-36.741-67.281-43.519-78.951 c-21.59-37.19-11.383-62.313-11.383-62.313s59.721-6.184,76.028-20.582l5.939,9.063c0,0,13.211,57.25,12.6,57.519 c0.646,1.945,1.304,3.927,1.971,5.943c10.363,31.484,22.297,70.843,28.852,102.911c3.685,18.044,5.666,33.771,4.69,44.497 c-0.335,3.679,0.12,9.329,1.131,16.302C687.144,1501.825,707.129,1574.489,707.129,1574.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6980E2"
    },
    d: "M736.333,1591.92l-57.922,0.269c0,0-1.429-8.821,1.565-15.533c2.869-6.44,7-6.663,0.45-16.707 c3.698,3.772,15.537,5.285,23.906,4.12c1.033,1.658,6.674,12.793,10.113,15.239 C718.243,1582.01,735.117,1580.962,736.333,1591.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#233862"
    },
    d: "M646.496,1297.011c-4.93,27.929-16.666,74.425-41.636,89.322 c-16.975-30.638-36.741-67.281-43.519-78.951c-21.59-37.19-11.383-62.313-11.383-62.313s59.721-6.184,76.028-20.582l5.939,9.063 c0,0,13.211,57.25,12.6,57.519C645.172,1293.013,645.829,1294.994,646.496,1297.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED7D2B"
    },
    d: "M751.994,1138.579c0,0,7.923,8.201,8.84,26.043c0,0-9.713,30.196-40.224,35.043 C720.61,1199.665,744.485,1138.6,751.994,1138.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B478B"
    },
    d: "M605.65,1249.12l0.146-10.835c-21.571,2.822-74.542-25.447-74.542-25.447 s-22.511,15.123-25.403,58.028c-1.412,20.942-10.546,109.521-11.479,135.964c-0.341,9.583-0.436,16.422-0.468,19.154 c0.005,0.014,0.004,0.021,0.003,0.027c-0.009,0.833-0.396,1.571-0.907,2.233c-4.439,5.697-8.286,11.729-11.612,17.981 c-32.651,61.432-15.042,144.617-15.042,144.617l7.639-1.98c0,0,27.449-86.446,45.477-123.868 c3.06-6.347,5.843-11.285,8.178-14.148c6.805-8.343,13.956-22.493,20.99-39.514c13.296-32.18,26.154-74.62,35.311-107.479 C584.597,1303.971,605.65,1249.12,605.65,1249.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M731.624,1176.231c-35.322-7.935-13.01-57.622-10.961-56.759 c4.884-1.019,15.582-9.652,25.109-26.463l1.303,1.12l21.76,18.899c0,0-4.976,7.414-9.156,14.671 c-3.267,5.683-6.04,11.279-5.586,13.193C755.843,1142.257,741.046,1178.351,731.624,1176.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED985F"
    },
    d: "M768.834,1113.035c0,0-4.977,7.404-9.156,14.671c-13.512-8.244-13.604-24.926-12.606-33.571 L768.834,1113.035z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M769.479,1122.549c0,0-32.8-18.053-21.244-38.307c11.557-20.253,15.107-36.224,36.538-25.554 c21.431,10.67,21.054,20.7,18.841,28.398C801.401,1094.785,778.309,1126.723,769.479,1122.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C3A64"
    },
    d: "M809.086,1075.28c-1.539-8.962-6.1-9.797-9.273-9.184c-12.175-19.925-31.877-12.035-31.877-12.035 c-10.482,13.28-25.714,15.608-25.714,15.608s3.83,7.046,19.492,11.346c4.784,1.313,10.204,0.479,15.425-1.305 c-10.824,6.101-22.163,8.472-22.163,8.472c20.622,1.791,40.147-17.146,42.172-19.171c0.965,2.916,2.661,9.022,1.683,13.497 c-1.329,6.081-6.67,17.108-3.371,18.517C795.459,1101.025,811.396,1088.72,809.086,1075.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6980E2"
    },
    d: "M512.417,1592.958l-57.922,0.269c0,0-1.43-8.822,1.565-15.533 c2.869-6.44,7.397-9.382,6.273-17.152c3.698,3.772,9.717,7.988,18.085,6.823c1.034,1.658,6.672,10.534,10.11,12.981 C494.326,1583.048,511.2,1582,512.417,1592.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M735.957,1215.52c-7.44,2.636-17.894,4.107-28.59,5.32c-15.223,1.733-30.942,2.943-39.165,6.267 c-2.998,1.213-5.001,2.701-5.62,4.597c-3.521,10.753-19.179,27.393-19.179,27.393c-100.88-4.123-112.149-46.259-112.149-46.259 c67.493-79.221,181.176-99.444,181.176-99.444s20.742-6.168,24.806,8.728c4.724,17.31,17.283,16.053,17.283,16.053 S757.854,1207.768,735.957,1215.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED7D2B"
    },
    d: "M707.367,1220.84c-15.223,1.733-30.942,2.943-39.165,6.267 c-3.6-50.286,19.963-88.232,19.963-88.232S703.943,1201.82,707.367,1220.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M722.618,1128.981c0,0-38.155,3.948-41.1,28.766s37.18,125.658,42.902,134.78 c10.417,16.605,71.565,73.409,71.565,73.409l11.19-6.853c0,0-43.524-72.908-50.242-79.719 C746.384,1268.672,735.582,1137.514,722.618,1128.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F99746"
    },
    d: "M682.688,1172.664c0.103,0.563,35.282,11.313,57.835-0.268c0,0,4.596-52.184-22.38-49.228 c-26.977,2.956-42.919,11.531-43.54,24.456C673.984,1160.55,682.688,1172.664,682.688,1172.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB27D"
    },
    d: "M792.481,1358.702c0,0,13.635-12.639,19.545-12.965c5.911-0.327,23.515,1.683,24.134,4.116 c0.62,2.435-18.037,7.153-19.079,8.717c-1.043,1.563-12.446,12.295-17.554,10.389 C794.42,1367.053,792.481,1358.702,792.481,1358.702z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M821.195,1524.957c-2.623-2.247-4.45-5.332-5.126-8.791l-14.441-73.857 c-1.642-8.394,3.833-16.528,12.228-18.17c8.393-1.641,16.529,3.832,18.17,12.228l10.634,54.382l103.213-48.396 c7.743-3.632,16.968-0.3,20.596,7.446c3.631,7.744,0.297,16.967-7.447,20.597l-121.178,56.82 c-4.319,2.026-9.33,1.946-13.583-0.211C823.149,1526.44,822.122,1525.751,821.195,1524.957z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1167179913146);
export default __webpack_public_path__ + "static/media/11671799_13146.d2d3753bf813d7cb2bc67afd72c30bcc.svg";
export { ForwardRef as ReactComponent };